// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uP2a","colBig":"styles_colBig__QfRgG","colSmall":"styles_colSmall__2M4MI"};